// extracted by mini-css-extract-plugin
export default {"row":"LoaderRow-module__row__wX-vb","cell":"LoaderRow-module__cell__J8LBZ","content":"LoaderRow-module__content__jM2Y+","text":"LoaderRow-module__text__Yicr0"};